import React, { useState } from 'react';
import "../Login.css"
import "./Password.css"
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import {Token, post} from "../../../Script/Session.js";
import { useNavigate } from 'react-router-dom';
import {setCookie, getCookie, cookieExists, deleteCookie} from "../../../Script/cookies.js";
import { getloginvalue } from '../../../Script/variables.js';
import { getEmail } from '../../../Script/variables.js';

const Password = () => {
    const navigate = useNavigate();
    const [aftercontentemail, setAfterContentemail] = useState("");
    const [afterContentpw, setAfterContentpw] = useState("");
    const [accwrong,setaccwrong] = useState("hidden");

    let elligalchars = false;
    const [buttonText, setButtonText] = useState('Anmelden');


    const changeinputtext = () => {
      setaccwrong("hidden");
      let us = document.getElementById("username");
      let pw = document.getElementById("password");

      if (us.value.includes(">")||us.value.includes("<") || us.value.includes('"') || us.value.includes("'") || us.value.includes(" ") || us.value.includes(":")){
        elligalchars = true
        us.style.borderColor =  "#ff0000";
        setAfterContentemail("Feld enthält ungültiges zeichen");
      }else {
        elligalchars = false
        us.style.borderColor =  "#ccc";
        setAfterContentemail("");
      }
      if (pw.value.includes(">") ||pw.value.includes("<") || pw.value.includes('"') || pw.value.includes("'") || pw.value.includes(" ") || pw.value.includes(":")){
        elligalchars = true
        pw.style.borderColor = "#ff0000";
        setAfterContentpw("Feld enthält ungültiges zeichen");
      }else {
        setAfterContentpw("");
        elligalchars = false;
        pw.style.borderColor = "#ccc";
      }
      

    };
    const login = (e) => {
      e.preventDefault();
      if (elligalchars){
        document.getElementById("username").blur();
        document.getElementById("password").blur();
        return;
      }
      let us = document.getElementById("username").value;
      let pw = document.getElementById("password").value;
      let body = {};
      body.email = getEmail();
      body.code = us;
      body.password = btoa(pw);
      let response = post(body, "/forgottpasswordauth")
      if (response != null) {
        alert("Ihr neues Passwort wurde gesetzt und ist aktiv. Loggen sie sich bitte neu ein!");
        navigate("/");
      }else {
        setaccwrong("visible");
        return;
      }


    }

    
    return (
        <div class="arounddev">
        <div class="login-container">
          <div className="email-header">
             <h1>Passwort vergessen</h1>
          </div>

            <label style={{ visibility: accwrong }} class="username-password-wrong-pw">Ungültiger Code!</label>
            <p className="faktorauth-p">Wir haben an ihre Email adresse eine Nachricht mit einem 2Faktor Authentifikations Code Gesendet</p>
            <form class="login-form" onSubmit={login}>

                <label class="login-label" for="username">Email Code</label>
                <div style={{ '--after-content': `"${aftercontentemail}"` }} id="emailerror" name="emailerror" class="login-after-div">
                    <input onChange={changeinputtext} class="login-input" type="text" id="username" name="username" ></input>
                </div>

                <label class="login-label" for="password">Neues Passwort</label>
                <div style={{ '--after-content': `"${afterContentpw}"` }} class="login-after-div-pw">
                    <input onChange={changeinputtext} class="login-input" type="password" id="password" name="password" ></input>
                </div>

                <div class="remember-me">

                </div>



                <button class="login-button" onClick={login} >
                    {buttonText}
                </button>
            </form>
        </div>
    </div>
    );

}
export default Password;